// @flow
import React, { Component } from 'react';
import { Form, DropdownDisableInputClear } from 'semantic-grab-ui/src';
import './DynamicHeightFormSelect.scss';

type Props = {
  disabled: any,
  options: any,
  value: any,
  multiple: any,
  className: string,
  onChange: Function,
  onBlur: Function,
}

export default class DynamicHeightFormMultipleSelect extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      mouseInside: false,
      dropDownOpen: false,
      dropDownMaxHeight: '125px', // we set max height to an exact number to enable us to do transition
    };
  }

  recalculateDropDownMaxHeight = () => {
    let maxHeight = '125px'; // back to default max height
    if (this.state.dropDownOpen || this.state.mouseInside) {
      maxHeight = `${(this.el ? (this.el.clientHeight || 0) : 0) * 1.5}px`;
    }
    this.setState({
      dropDownMaxHeight: maxHeight,
    });
  };

  handleDropDownOpen = () => {
    this.setState({
      mouseInside: true,
      dropDownOpen: true,
    });
    // use set timeout to allow the component gets rendered with new height first
    setTimeout(this.recalculateDropDownMaxHeight);
  };

  handleDropDownClose = () => {
    this.setState({
      dropDownOpen: false,
    });
    setTimeout(this.recalculateDropDownMaxHeight);
  };

  handleMouseEnter = () => {
    clearTimeout(this.mouseLeaveTimeout);
    if (this.state.dropDownOpen) {
      this.setState({
        mouseInside: true,
      });
      setTimeout(this.recalculateDropDownMaxHeight);
    }
  };

  handleMouseLeave = () => {
    // give 1 sec delay for this, will cancel the timeout if the mouse enters the dropdown
    this.mouseLeaveTimeout = setTimeout(() => {
      this.setState({
        mouseInside: false,
      });
      setTimeout(this.recalculateDropDownMaxHeight);
    }, 1000);
  };

  render() {
    const { mouseInside, dropDownOpen, dropDownMaxHeight } = this.state;
    const { disabled, options, value, multiple } = this.props;
    let dropDownClassName = '';
    if (mouseInside) {
      dropDownClassName += ' mouse-inside';
    }
    if (dropDownOpen) {
      dropDownClassName += ' drop-down-open';
    }

    if ((value || []).length === 0) {
      dropDownClassName += ' drop-down-value-empty';
    }

    return (
      <div className={`dynamic-height-form-select ${this.props.className || ''}`} ref={(el) => { this.el = el; }}>
        <Form.Select
          control={DropdownDisableInputClear}
          style={{ maxHeight: dropDownMaxHeight }}
          className={dropDownClassName}
          multiple={multiple}
          disabled={disabled}
          options={options}
          value={value}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          onOpen={this.handleDropDownOpen}
          onClose={this.handleDropDownClose}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          {...this.props}
        />
      </div>
    );
  }
}
